// extracted by mini-css-extract-plugin
module.exports =  {"withoutDialog":"C1nqQN","withDialog":"SqOfBn"};